import React from 'react';

// Material UI
import Grid from '@mui/material/Grid';
import { useNavigate, useParams } from 'react-router-dom'
import Button from '@mui/material/Button';
import ErrorIcon from '@mui/icons-material/Error';
import Typography from '@mui/material/Typography';

import useStyle from './styles';

const OrderFailedView = () => {
    const { orderId } = useParams();
    const { classes } = useStyle();
    const push = useNavigate();

    return (
        <Grid container spacing={1} direction='column' alignItems="center">
            <Grid>
                <ErrorIcon className={classes.errorIcon} />
            </Grid>
            <Grid>
                <Typography variant="h4" component="h2">
                    El pago no pudo ser procesado correctamente
                </Typography>
            </Grid>
            <Grid container spacing={1} justifyContent="center" alignContent="center">
                <Grid>
                    <Button variant="contained" color="primary" onClick={() => push(`/orders/${orderId}`)}>
                        Reintentar
                    </Button>
                </Grid>
                <Grid>
                    <Button variant="outlined" color="primary" onClick={() => push(`/orders`)}>
                        Crear nueva orden
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default OrderFailedView;